<template lang="pug">
  .CompanyProfile
    .content
      h1(:class="titleAnimation") 我们是谁？
      h2(:class="titleAnimation") Company Profile
      .subTitle(:class="contentAnimation") {{ title }}
      p(:class="contentAnimation") {{ text }}
    .background
</template>

<script>
  import Mixin from '../index.js'
  export default {
    name: "CompanyProfile",
    mixins: [Mixin],
    data() {
      return {
        title: "Welcome to the AlphaCloud World",
        text:
          '阿尔法云计算（深圳）有限公司（AlphaCloud）是全球领先的云计算及人工智能的科技公司，致力于智慧安全、智慧教育、智慧金融、智慧健康的研发及智能化运营，重新定义行业、重塑行业流程，推动行业智慧化进程。\n\n' +
          'AlphaCloud由全球顶级云计算、大数据、AI专家创建，核心成员来自于腾讯、阿里、百度、大疆等知名企业。AlphaCloud拥有行业领先的、自主知识产权的高度自动化、智能化的云操作系统（HAMIS）：包括连接、计算、数据、AI、内容、交易六大中台，决策分析、数据可视、营销、服务开放四大平台，指挥、会员积分两大中心，一个智能引擎；AlphaCloud具备云计算IaaS、PaaS、SaaS、DaaS研发、行业智能运营、平台智能服务的能力，与AWS、Azure、AliCloud、GoogleCloud、Tencent有丰富的合作经验。\n\n' +
          '云有界，智无疆。AlphaCloud基于云计算、AI、IoT、边缘计算等基础能力，让我们一起重新定义，一起畅想未来生活的新形态。',
        contentAnimate: "animated fadeInLeft",
      };
    },
  };
</script>

<style scoped lang="stylus">
  @import "../index.styl"
  .CompanyProfile {
    position relative
    padding 100px 0
    background url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E5%A4%A7%E5%9B%BE/%E6%98%9F%E7%A9%BA%E5%BA%95%E6%9D%BF.png") no-repeat center
    background-size 100% 100%
    background-color black
    HStack(center, center)
    .background {
      width 537px
      height 593px
      margin-bottom -100px
      align-self flex-end
      background url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%83%8C%E6%99%AF%E5%A4%A7%E5%9B%BE/%E5%AE%87%E8%88%AA%E5%91%98.png") no-repeat center 100%
  }
    .content {
      VStack(center, center)
      width 654px;
      > h1, > h2, > .subTitle {
        color white
      }
      > .subTitle {
        margin-top 65px
        margin-bottom 20px
        font-size 20px
        FontSetting(Lora)
        font-weight 600
        font-style italic
        text-align left
        width 100%
      }
      > p {
        color #999
        line-height 30px
        font-size 14px
        FontSetting("思源黑体")
        font-weight 200
        max-width 100%
      }
      h1 {
        &::after {
          background-color white
        }
      }
    }
    @media (max-width ipadProScreenWidth) {
      padding 100px 20px
      .content {
        position relative
        z-index 2
      }
      .background {
        position absolute
        right 0
        bottom 0
        margin-bottom 0
        filter brightness(.3)
      }
    }
    @media (max-width screenWidth) {
      padding 50px 0
      width 100vw
      VStack(center)
      .content {
        width 100vw
        box-sizing border-box
        padding 0 20px
        > .subTitle {
          width 100%
          margin-top 30px
          padding 0 20px
        }
      }
      .background {
        display none
      }
    }
  }
</style>
